"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FtEditor = void 0;
const tslib_1 = require("tslib");
const Utilities_1 = require("../../../javascript/Utilities");
const FtEditorControl_1 = require("../../Menu/45/FtEditorControl");
const ExternalInput_1 = require("./ExternalInput");
/**
* ForeignTable Editor
*/
class FtEditor extends ExternalInput_1.ExternalInput {
    constructor(controlColl, currentInstance, methodName) {
        super(controlColl, currentInstance, methodName);
        this.methodName = methodName;
        this.forceRefreshOnOk = true;
        this.windowContentCssClass = "eiFtEditor";
        this.windowActions = ["Maximize", "Close"];
    }
    destroyWidgets() {
        if (this.m_ftEditorControl)
            this.m_ftEditorControl.destroy();
    }
    getFtObjectId(ftName) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let results = yield Utilities_1.synUtil.searchAsync(999999978 /*ForeignTable*/, { "ceforeigntable.ceforeigntablename": ftName }, ["id"]);
            if (results.length !== 1)
                results = yield Utilities_1.synUtil.searchAsync(999999978 /*ForeignTable*/, { "ceforeigntable.cesynonyms": ftName }, ["id"]);
            return results.length === 1 ? results[0].id.valueAsString : undefined;
        });
    }
    initWindowContents() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let that = this;
            let $ftEditorControl = $("<div></div>").css("height", "100%").appendTo(that.widgetContainer);
            that.windowData.beginInit();
            let fieldName = that.input.field.fieldName;
            try {
                let ftId = yield that.getFtObjectId(fieldName.substring(0, fieldName.indexOf(".")));
                that.m_ftEditorControl = new FtEditorControl_1.FtEditorControl($ftEditorControl, ftId);
                yield that.m_ftEditorControl.init();
                let dialog = that.windowData.windowDiv.data("kendoWindow");
                dialog.setOptions({
                    resizable: true,
                    minWidth: that.windowMinWidth == undefined ? that.windowWidth : that.windowMinWidth,
                    minHeight: that.windowMinHeight == undefined ? that.windowHeight : that.windowMinHeight
                });
                that.windowData.endInit();
            }
            catch (_a) {
                that.destroyWindow();
                that.callback(true, undefined, undefined, false);
            }
        });
    }
}
exports.FtEditor = FtEditor;
